import { useMemo, useState } from 'react';

export function useDashboardData() {
  const [mes, setMes] = useState(new Date().getMonth());
  const [anio, setAnio] = useState(new Date().getFullYear());

  const ventas = JSON.parse(localStorage.getItem('libroVentasData') || '[]');
  const compras = JSON.parse(localStorage.getItem('libroComprasData') || '[]');
  const gastos = JSON.parse(localStorage.getItem('libroGastosData') || '[]');

  const filtrarPorMes = data =>
    data.filter(d => {
      const fecha = new Date(d.fecha);
      return (
        fecha.getMonth() === mes &&
        fecha.getFullYear() === anio &&
        d.estado !== 'ANULADA'
      );
    });

  const ventasMes = filtrarPorMes(ventas);
  const comprasMes = filtrarPorMes(compras);
  const gastosMes = filtrarPorMes(gastos);

  const totalVentas = ventasMes.reduce((s, v) => s + Number(v.monto || 0), 0);
  const totalCompras = comprasMes.reduce((s, c) => s + Number(c.monto || 0), 0);
  const totalGastos = gastosMes.reduce((s, g) => s + Number(g.monto || 0), 0);

  const utilidad = totalVentas - totalCompras - totalGastos;

  const graficoData = [
    { name: 'Ventas', value: totalVentas },
    { name: 'Compras', value: totalCompras },
    { name: 'Gastos', value: totalGastos },
  ];

  return {
    mes,
    setMes,
    anio,
    setAnio,
    totalVentas,
    totalCompras,
    totalGastos,
    utilidad,
    graficoData,
  };
}
